import { all, update, remove } from '../services/restApi'
import { message } from 'antd'
message.config({top: 110, duration: 4});
const _ = require('underscore')

const limit = 50;

export default {
	namespace : 'boucher_adon',
	state : {
		boucher_adons: [],
		skip: 0,
		limit: limit,
		total_items: 0
	},
	subscriptions : {
		setup({dispatch, history}) {

			history.listen(location => {
		        if (location.pathname === '/adons/list-adons') {
		          	dispatch({type: 'firstLoad'})
		        }
		    })
		}
	},
	effects : {
		*firstLoad({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {

				let query = {};
				let currentUser = JSON.parse(localStorage.getItem('currentUser'));

				if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
					query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: JSON.parse(localStorage.getItem('currentHotel')).objectId}

				if (currentUser.type === 'recepcionista') {
					query.createdBy = {__type: 'Pointer', className: '_User', objectId: currentUser.objectId}
				}

				const resp = yield call(all, 'BoucherAdon', {
					where: query,
					include: 'hotel,createdBy,adons',
					skip: 0, 
					limit: limit, 
					count: 1, 
					order: '-requestedAt'
				});
				console.log(resp);

				yield put({ type: 'queryFirst', payload: {
					boucher_adons: resp.results, 
					skip: limit,
					total_items: resp.count,
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*query({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				const resp = yield call(all, 'BoucherAdon', {...payload, include: 'hotel,createdBy'})

				yield put({ type: 'querySuccess', payload: {
					boucher_adons: resp.results,
					skip: payload.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*filter({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				const resp = yield call(all, 'BoucherAdon', {...payload, include: 'hotel,createdBy'})

				yield put({ type: 'filterSuccess', payload: {
					boucher_adons: resp.results,
					skip: payload.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*update({payload}, {call, put}) {
			yield put({type: 'app/showButtonLoading'})

			try {

				let data = {...payload}
				data = _.omit(data, ['objectId', 'createdAt', 'updatedAt']);

				yield call(update, 'BoucherAdon', payload.objectId, data);
				yield put({ type: 'updateSuccess', 
					payload: {
						...data, 
						objectId: payload.objectId} 
				})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideButtonLoading'})

		},
		*removeItem({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				yield* payload.adons.map(item => {
					return call(remove, 'BoucherAdonItem', item.objectId)
				});

				yield call(remove, 'BoucherAdon', payload.objectId);
				yield put({type: 'removeSuccess', payload: payload});

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideLoadingTable'})

		}
	},
	reducers : {
		queryFirst(state, action) {
			return {
				...state,
				...action.payload
			}
		},
		querySuccess(state, action) {
			return {
				...state,
				boucher_adons: state.boucher_adons.concat(action.payload.boucher_adons),
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		filterSuccess(state, action) {
			return {
				...state,
				boucher_adons: action.payload.boucher_adons,
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		updateSuccess(state, action) {
			const obj = _.find(state.boucher_adons, {objectId: action.payload.objectId})
			_.extend(obj, action.payload)
			return {
				...state,
    			...action.payload
			}
		},
		removeSuccess(state, action) {
			return {
				...state,
    			boucher_adons: _.without(state.boucher_adons, action.payload)
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/models/boucherAdon.js